export default "__VITE_ASSET__c2268090__"